import request from '@/utils/request';

export function WorksListAPI() {
  return {
    // 列表
    getWorksList: params => {
      return request({
        url: '/admin/novel/list',
        method: 'get',
        params,
      });
    },
    // 分类列表
    classifyList: params => {
      return request({
        url: '/admin/novel/category/select',
        method: 'get',
        params,
      });
    },
    //新增
    WorksAdded: data => {
      return request({
        url: '/admin/novel/edit',
        method: 'post',
        data
      });
    },
    // 上传封面
    fileUpload: data => {
      return request({
        url: '/admin/upload/cover',
        method: 'post',
        data
      });
    },
    // 详情数据
    detailsList: params => {
      return request({
        url: `/admin/novel/info?id=${params}`,
        method: 'get',
      });
    },
    // 删除
    DelList: data => {
      return request({
        url: '/admin/novel/delete',
        method: 'post',
        data
      });
    },
    // 小说列表
    VideoList: params => {
      return request({
        url: `/admin/novel/chapter/list?id=${params}`,
        method: 'get',
      });
    },
    //获取播放地址
    getPlayUrl: params => {
      return request({
        url: '/admin/novel/episodes/playurl',
        method: 'get',
        params,
      });
    },

    // 抖音类目
    getTags: params => {
      return request({
        url: '/admin/bytedance/tags',
        method: 'get',
        params,
      });
    },

    //上传成本配置比例
    fileDistributionUpload: data => {
      return request({
        url: '/admin/upload/distribution',
        method: 'post',
        data
      });
    },

    //上传承诺书
    filePromiseUpload: data => {
      return request({
        url: '/admin/upload/promise',
        method: 'post',
        data
      });
    },

    // 获取已上架小说
    getVisibleList: params => {
      return request({
        url: '/admin/novel/list_visible',
        method: 'get',
        params,
      });
    },
    // 抖音媒资列表
    getCataloglist: params => {
      return request({
        url: '/admin/novel/catalog_list',
        method: 'get',
        params,
      });
    },
    // 微信提审
    getReview: params => {
      return request({
        url: '/admin/novel/wechat/submit_review_wx',
        method: 'post',
        params,
      });
    },
    // 微信重审
    againReview: params => {
      return request({
        url: '/admin/novel/wechat/agaign_submit_review_wx',
        method: 'post',
        params,
      });
    },
     // 抖音媒资信息
     getresourcesy: data => {
      return request({
        url: '/admin/novel/media_resources',
        method: 'post',
        data,
      });
    },
     // 详情数据
     medialsList: params => {
      return request({
        url: `/admin/novel/media_info?id=${params}`,
        method: 'get',
      });
    },
    //小说分类
     wechattype: params => {
      return request({
        url: `/admin/novel/wechat/type?type=${1}`,
        method: 'get',
      });
    },
  };
}
